/* eslint-disable */
export const generateAblageProject = (projectName, id) => {
	return {
		[`${id}`]: {
			projectName,
			id,
			projectData: {},
		},
	};
};

export const generateAblageLocation = (locationName, id, projectID) => {
	return {
		[`${projectID}_${id}`]: {
			location: locationName,
			street: '',
			housenumber: '',
			postalcode: '',
			city: '',
			optimizationTarget: '',
			roofArea: '',
			id: `${projectID}_${id}`,
			customerData: {},
		},
	};
};

export const generateAblageCustomer = (lastgangID) => {
	return {
		[`${lastgangID}`]: {
			year: null,
			id: lastgangID,
			stromverbrauch: '',
			einsparpotential: '',
			spannungsebene: '',
			netzbetreiber: '',
		},
	};
};
